/**
 * Created by matheusmorett on 16/08/17.
 */
import SiteTemplate from './SiteTemplate.js';
export default SiteTemplate;
